var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_check_circle",
    "data-name": " check_circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.376,
    height: 45.376,
    viewBox: "0 0 45.376 45.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 45.376,
    height: 45.376,
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.969,37.938A18.969,18.969,0,1,1,37.938,18.969,18.99,18.99,0,0,1,18.969,37.938ZM8.355,17.067A1.891,1.891,0,0,0,7.018,20.3l6.81,6.81a1.888,1.888,0,0,0,1.344.554,1.839,1.839,0,0,0,1.33-.554l14.4-14.4a1.891,1.891,0,1,0-2.675-2.674l-13.05,13.05L9.692,17.622A1.878,1.878,0,0,0,8.355,17.067Z",
    transform: "translate(3.719 3.719)",
    fill: "#cacaca",
    opacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.c554dc67a1a2a803feb712f87db32300.svg";
export { ForwardRef as ReactComponent };